export default __webpack_public_path__ + "static/media/QF img.420569cc.png";